import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileIos"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 17.25H18C17.1716 17.25 16.5 16.5784 16.5 15.75V8.25C16.5 7.42157 17.1716 6.75 18 6.75H21C21.8284 6.75 22.5 7.42157 22.5 8.25V15.75C22.5 16.5784 21.8284 17.25 21 17.25ZM18 8.25V15.75H21V8.25H18ZM13.5 17.25H9V15.75H13.5V12.75H10.5C9.67157 12.75 9 12.0784 9 11.25V8.25C9 7.42157 9.67157 6.75 10.5 6.75H15V8.25H10.5V11.25H13.5C14.3284 11.25 15 11.9216 15 12.75V15.75C15 16.5784 14.3284 17.25 13.5 17.25ZM1.5 8.25H3.75V15.75H1.5V17.25H7.5V15.75H5.25V8.25H7.5V6.75H1.5V8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileIos.vue"]]);
